export default __webpack_public_path__ + "static/media/check.61172991.mp3";